module.exports = __webpack_public_path__ + "static/media/abouticon4.bc7d180a.svg";